import PropTypes from "prop-types";

import { Box, IconButton, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

const NarrativeSegmentButtons = ({
  userId,
  createdById,
  segment,
  onEdit,
  onDelete,
  isOffline = false,
}) => {
  if (!userId || !createdById) return null;
  if (userId?.toString() !== createdById.toString()) return null;
  return (
    <Box
      display="flex"
      flexDirection="row"
      data-testid="narrative-segment-buttons-container"
    >
      <Tooltip
        title={isOffline ? "Editing is not allowed while offline" : "Edit"}
        placement="top"
      >
        <IconButton
          edge="start"
          onClick={() => onEdit(segment)}
          style={{ height: "fit-content", width: "fit-content" }}
          data-testid="narrative-segment-edit-button"
          disabled={isOffline}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={isOffline ? "Deleting is not allowed while offline" : "Delete"}
        placement="top"
      >
        <IconButton
          edge="start"
          onClick={() => onDelete(segment.id)}
          style={{ height: "fit-content", width: "fit-content" }}
          data-testid="narrative-segment-delete-button"
          disabled={isOffline}
        >
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

NarrativeSegmentButtons.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createdById: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  segment: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isOffline: PropTypes.bool,
};

export default NarrativeSegmentButtons;
